module.exports = __webpack_public_path__ + "img/2.d4178158.png";